import { SVGProps } from 'react';

const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
        <path d="M6 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5.25c2.002 0 6 .997 6 3V12H0V9.75c0-2.003 3.998-3 6-3Zm0 1.425c-2.228 0-4.575 1.095-4.575 1.575v.825h9.15V9.75c0-.48-2.348-1.575-4.575-1.575Z" />
    </svg>
);
export default SvgPerson;
